var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8701 8.71973C12.163 8.42703 12.6378 8.4269 12.9307 8.71973L15.4609 11.25L12.9307 13.7803C12.6378 14.0731 12.163 14.0729 11.8701 13.7803C11.5772 13.4874 11.5773 13.0126 11.8701 12.7197L12.5898 12H7.65039C7.2362 12 6.90042 11.6642 6.90039 11.25C6.9004 10.8358 7.23618 10.5 7.65039 10.5H12.5898L11.8701 9.78027C11.5772 9.48739 11.5773 9.01262 11.8701 8.71973ZM13 0C14.1046 0 15 0.895431 15 2V7H13.5V4.5H8.25V7H6.75V4.5H1.5V10C1.5 10.2761 1.72386 10.5 2 10.5H4.5V12H2L1.7959 11.9893C0.854346 11.8938 0.1062 11.1457 0.0107422 10.2041L0 10V2C1.28853e-07 0.895431 0.895431 5.63724e-08 2 0H13ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V3H6.75V1.5H2ZM8.25 3H13.5V2C13.5 1.72386 13.2761 1.5 13 1.5H8.25V3Z",
    fill: "#C2D1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspense);
export default __webpack_public_path__ + "static/media/suspense.1c15e4dd06a0aa7b4e83657f63a92f8c.svg";
export { ForwardRef as ReactComponent };